import { render, staticRenderFns } from "./create-track.vue?vue&type=template&id=5b8a11d6&scoped=true"
import script from "./create-track.vue?vue&type=script&lang=js"
export * from "./create-track.vue?vue&type=script&lang=js"
import style0 from "./create-track.vue?vue&type=style&index=0&id=5b8a11d6&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import style1 from "./create-track.vue?vue&type=style&index=1&id=5b8a11d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8a11d6",
  null
  
)

export default component.exports